"use client";

import Link from "next/link";

export default function BusinessError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <section className="w-full max-w-lg rounded-lg border border-border bg-card p-7 shadow-soft">
        <p className="text-[11px] font-black uppercase tracking-[0.22em] text-nv-red">Business workspace</p>
        <h1 className="mt-3 text-2xl font-black tracking-tight">Your workspace could not load.</h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">Retry the request or return to your account page.</p>
        <div className="mt-6 flex gap-3">
          <button type="button" onClick={reset} className="nv-button">Try again</button>
          <Link href="/account" className="nv-button-secondary">Account</Link>
        </div>
      </section>
    </main>
  );
}
